import { Fragment } from 'react'

import { segmentMentions, MentionableEmployee } from 'src/lib/mentions.utils'
import { cn } from 'src/utils'

interface MentionTextProps {
  content?: string | null
  recruiters?: MentionableEmployee[] | null
  className?: string
  mentionClassName?: string
}

/**
 * Note text with each recognised @-mention set apart from the prose. Rendered
 * as one inline span so a flex or grid parent treats it as a single item.
 */
const MentionText = ({
  content,
  recruiters,
  className,
  mentionClassName,
}: MentionTextProps) => (
  <span className={className}>
    {segmentMentions(content, recruiters).map((segment, index) =>
      segment.mention ? (
        <span
          key={index}
          className={cn(
            'font-semibold text-doubleNickel-brand-700',
            mentionClassName
          )}
          data-mention-id={segment.mention.value}
        >
          {segment.text}
        </span>
      ) : (
        <Fragment key={index}>{segment.text}</Fragment>
      )
    )}
  </span>
)

export default MentionText
